import { forwardRef } from "react";
import { graphql, useFragment } from "react-relay";

import type { DefaultComponentsProvider } from "~/components/content/content-item-render";
import type { postiesSectionSecondaryContentItemContent$key } from "~/queries/__generated__/postiesSectionSecondaryContentItemContent.graphql";

import {
  Container,
  Content,
  DateContainer,
  Headline,
  StyledArrowButton,
  StyledContentCoverImage,
  StyledEntityLink,
  StyledOffsetContainer,
} from "./styles";

export type Props = {
  className?: string;
  provider: DefaultComponentsProvider;
  reference: postiesSectionSecondaryContentItemContent$key;
};

export const ContentItemPostiesSectionSecondary = forwardRef<HTMLDivElement, Props>(
  ({ className, provider, reference: reference_ }, reference) => {
    const content = useFragment(
      graphql`
        fragment postiesSectionSecondaryContentItemContent on Content {
          ...entityLink
          ...contentCoverImageContent
        }
      `,
      reference_,
    );

    return (
      <Container className={className} ref={reference}>
        <StyledEntityLink reference={content}>
          <StyledOffsetContainer borderRadius="12px">
            <StyledContentCoverImage
              reference={content}
              responsiveVariants={{
                desktopUp: "size320x240",
                mobileUp: "size540x360",
                tabletUp: "size320x240",
              }}
            />
          </StyledOffsetContainer>
          <Content>
            <Headline>
              {provider.headline({
                hideTag: true,
                preferSocialHeadline: true,
              })}
            </Headline>
            <DateContainer>{provider.publishedDate({})}</DateContainer>
            <StyledArrowButton />
          </Content>
        </StyledEntityLink>
      </Container>
    );
  },
);

ContentItemPostiesSectionSecondary.displayName = "ContentItemPostiesSectionSecondary";
